import * as React from 'react';
import * as UserActions from '../../actions/users';
import { RouteComponentProps } from 'react-router';
import { UserData } from '../../models/User';

export namespace Replay {
	export interface Props extends RouteComponentProps<void> {
		duration: number;
		replay: (e) => void;
	}

	export interface State {

	}
}

export const Overlay: React.SFC<Replay.Props> = (props) => {

	let duration = Math.floor(props.duration / 60) + ":" + (props.duration % 60 < 10 ? "0" : "") + (props.duration % 60);

	return (
		<div className="am_overlay" onClick={(e)=>{console.log("CLICKED");props.replay(e)}}>
			VOIT TOISTAA TARINASI TÄSTÄ<br/><br/>
			<img src="/images/Play.png"/>

			{/*KESTO:<br/> 
			{props.duration}*/}
		</div>
	);
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Play/replay.tsx